module.exports = __webpack_public_path__ + "img/logo-lion-parcel.1e3c7314.png";